import { InjectionToken } from '@angular/core';

import { ExchangeApiService } from '@kr/components/exchange/api/exchange-api.service';

export const EXCHANGE_API = new InjectionToken<ExchangeApiService>('EXCHANGE_API ');
